"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { getDataTestId } from "../../../Util/index.js";
const COMPONENT_NAME = "TabPanel";
const TabPanel = forwardRef(
  ({ ariaLabelledBy, children, selectedTabIndex, id, index }, ref) => {
    return /* @__PURE__ */ jsx(
      "div",
      {
        "aria-labelledby": ariaLabelledBy,
        "data-testid": getDataTestId(COMPONENT_NAME, id),
        role: "tabpanel",
        hidden: selectedTabIndex !== index,
        id,
        ref,
        tabIndex: -1,
        children
      }
    );
  }
);
TabPanel.displayName = COMPONENT_NAME;
export {
  TabPanel
};
